import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from 'src/app/services/modal.service';
import { PlannerService } from '../../services/planner.service';
import { PlanStatus } from '../planner-edit/constants/PlanStatus.const';
import { errorResponse } from '../../interfaces/ErrorResponse';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  providers: [
    PlannerService
  ]
})
export class FooterComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() public errorData: errorResponse;
  @Input() isSaving: boolean;
  @Output() validateAndSavePlan = new EventEmitter();
  planStatus: any = PlanStatus;
  erroDataFieldPos: number;
  disableFooterButtonsBasedOnStatus: boolean;

  constructor(private plannerService: PlannerService,
    private activatedRoute: ActivatedRoute,
    private modal: ModalService) { }

  ngOnInit() {
    this.disableFooterButtonsBasedOnStatus = this.plannerService.isPlanFormEditable(this.status.value);
  }

  public cancel(): void {
    if (this.group.dirty) {
      this.modal.confirmation({ message: 'Are you sure you want to discard the changes?' },
        () => {
          this.redirectToListPage();
        }
      )
    } else {
      this.redirectToListPage();
    }
  }

  public submit(status?: string): void {
    //Show modal when user edits a plan that is in PreviewReady
    if (this.status.value === this.planStatus.PreviewReady.key) {
      this.modal.confirmation({ message: 'Your previously generated media plan will be invalidated and no longer accessible' },
        () => {
          this.status.patchValue(status);
          this.validateAndSavePlan.emit();
        });
    } else {
      // validate and update plan object before saving
      if (status) {
        this.status.patchValue(status);
      }
      this.validateAndSavePlan.emit();
    }
  }

  private redirectToListPage() {
    this.plannerService.redirectToList(this.activatedRoute.snapshot.queryParams['advertiserId'] || this.advertiserId,
      this.activatedRoute.snapshot.queryParams['marketId'] || this.marketId);
  }

  //Scoll to element id based on errorField received in backend error response.
  scrollToErrorField(id: string, objectId: number, event): void {
    if (id) {
      let el = objectId && objectId >= 1 ? document.getElementById(id + objectId) : document.getElementById(id);
      if (el) {
        this.erroDataFieldPos = el.offsetTop;
        window.scrollTo({ top: this.erroDataFieldPos, behavior: 'smooth' });
      }
    }
  }

  get advertiserId() {
    return this.group.get('advertiserId').value;
  }

  get marketId() {
    return this.group.get('marketId').value;
  }

  get status(): FormControl {
    return this.group.get('status') as FormControl;
  }

}
